import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import classNames from "classnames";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BlockIcon from "@mui/icons-material/Block";
import withStyles from "utils/withStyles";
import { compose } from "redux";
import { connect } from "react-redux";
import clsx from "classnames";
import {
  updateActiveRouteAction,
  updateActiveSubRouteIndexAction,
  toggleFullScreen,
} from "../../../redux/actions";
import { upperRoutes, downRoutes, FE_ICONS } from "./constants";
import { getPreferenceValue } from "../../../helpers";
import { domainLevelConfig } from "../../../ui-config";
import sidebar_open from "../../../assets/icons/sidebar/sidebar_open.png";
import sidebar_close from "../../../assets/icons/sidebar/sidebar_close.png";
import _ from "lodash";
import styles from "./styles";
import cx from "classnames";

const redirect = (route, props) => {
  props.updateActiveRoute(route);
  props.updateActiveSubRouteIndex(0);
};

const redirectToApp = (app, props) => {
  if (app.app_slug) {
    props.updateActiveRoute(app);
    props.updateActiveSubRouteIndex(0);
  }
};

const processRoutes = (props, apps) => {
  const hostConfig =
    domainLevelConfig[props.host] || domainLevelConfig["default"] || {};

  const routeMaster = [...props.routeMaster];
  const customer_type = ((props.currentUser || {}).company || {}).customer_type;
  if (customer_type === "Home" || customer_type === "Enterprise") {
    const my_device_route_index = routeMaster.findIndex(
      (x) => x.key === "ca_sensors"
    );
    const customer_route_index = routeMaster.findIndex(
      (x) => x.key === "ca_facilities"
    );
    if (my_device_route_index > -1 && customer_route_index > -1) {
      const my_device_route = routeMaster[my_device_route_index];
      const customer_route = routeMaster[customer_route_index];
      my_device_route.label = hostConfig.sideLabel
        ? hostConfig.sideLabel
        : "Microwaves";
      routeMaster[customer_route_index] = my_device_route;
      routeMaster[my_device_route_index] = customer_route;
    }
  }

  const device_management_index = routeMaster.findIndex(
    (x) => x.key === "sa_device_management"
  );

  const device_management_app_index = apps?.findIndex(
    (x) => x.app_slug === "device-management"
  );

  if (device_management_index > -1 && device_management_app_index > -1) {
    const app = apps.find((x) => x.app_slug === "device-management");
    routeMaster[device_management_index].label = app.name;
    routeMaster[device_management_index].icon = app.icon;
  }

  return routeMaster;
};

const Sidebar = (props) => {
  const _ponytailDefaults = {
  routeMaster: [],
};
  props = { ..._ponytailDefaults, ...props };

  const [failedIcons, setFailedIcons] = useState(new Set());
  const hostConfig =
    domainLevelConfig[props.host] || domainLevelConfig["default"] || {};
  const classes = styles({
    ...props,
    hostConfig: hostConfig,
  });
  const routeMaster = processRoutes(props, props.currentUser.apps);
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <div className={classes.root}>
      <Drawer
        variant={"permanent"}
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: props.fullscreen,
          [classes.drawerClose]: !props.fullscreen,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: props.fullscreen,
            [classes.drawerClose]: !props.fullscreen,
          }),
        }}
      >
        <button
          onClick={() => {
            props.toggleFullScreen();
            // ApexCharts only reflows on window resize — nudge it after the drawer animates
            setTimeout(() => window.dispatchEvent(new Event("resize")), 300);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            margin: "12px 0",
            outline: "none",
            textAlign: "left",
            paddingLeft: isSmUp ? "24px" : "16px",
          }}
        >
          <img
            src={props.fullscreen ? sidebar_close : sidebar_open}
            style={{
              color: "rgba(0, 0, 0, 0.54)",
            }}
            alt="sidebar"
            width={24}
            height={24}
          />
        </button>
        {/* start sidebar logo */}
        <div className={classes.navLogoWrapper}>
          <div className={classes.navLogo}></div>
        </div>
        {/* end sidebar logo */}
        {/**
            here `route.id` is the check for the app, if the route is an installable app, it has this unique id field
          */}
        <List className={cx("hide-scrollbar", classes.list)}>
          <>
            {_.concat(
              upperRoutes,
              _.sortBy(
                _.concat(
                  routeMaster,
                  _.filter(props.currentUser.apps, (x) => x.is_installed)
                ),
                (x) => (x.label ? x.label : x.name)
              ),
              downRoutes
            ).map((route, index) => {
              if (!route.visible && !route.id) {
                return null;
              }
              if (route.id) {
                if (
                  route.app_slug === "device-management" ||
                  route.app_slug === "logs"
                ) {
                  return null;
                }
              }
              if (route.label === "Microwaves") {
                return null;
              }
              if (route.onlySA && props.currentUser.type !== "SA") {
                return null;
              }
              if (props.currentUser.type === "EM" && !route.app_slug) {
                return null;
              }
              if (
                props.currentUser.type === "FO" &&
                route?.app_slug?.toLowerCase() !== "inventory"
              ) {
                return null;
              }

              const iconFill = (
                route.id
                  ? route.app_slug === props.activeRoute.app_slug
                  : route.key === props.activeRoute.key
              )
                ? props.theme.palette.primary.main || hostConfig.themeColor
                : "#757575";

              // Fix width/height first
              const iconSize = {
                width: "24px",
                height: "24px",
              };
              const devicePreference = getPreferenceValue(
                props.currentUser.preference,
                route.label_key || ""
              );
              const typographyStyle = clsx([
                (
                  route.id
                    ? route.app_slug === props.activeRoute.app_slug
                    : route.key === props.activeRoute.key
                )
                  ? classes.activeList
                  : classes.inactiveList,
              ]);
              const divStyle = clsx({
                [classes.bold]: route.id
                  ? route.app_slug === props.activeRoute.app_slug
                  : route.key === props.activeRoute.key,
                [classes.normal]: !(route.id
                  ? route.app_slug === props.activeRoute.app_slug
                  : route.key === props.activeRoute.key),
              });

              return (
                <div key={route.key || route.app_slug || route.id || index} className={divStyle}>
                  <Link
                    to={route.path ? route.path : `/${route.app_slug}`}
                    className={classes.listItemLink}
                    onClick={() =>
                      route.id
                        ? redirectToApp(route, props)
                        : redirect(route, props)
                    }
                  >
                    <ListItem
                      className={classNames(classes.listItem, {
                        [classes.active]: route.id
                          ? route.app_slug === props.activeRoute.app_slug
                          : route.key === props.activeRoute.key,
                      })}
                      onClick={() =>
                        route.id
                          ? redirectToApp(route, props)
                          : redirect(route, props)
                      }
                    >
                      <ListItemIcon className={classes.listItemIconStyle}>
                        <div className={classes.listItemIconContainer}>
                          {typeof route.sidebar_icon !== "string" &&
                          route.sidebar_icon != null ? (
                            <route.sidebar_icon {...iconSize} fill={iconFill} />
                          ) : FE_ICONS[route.app_slug] ? (
                            FE_ICONS[route.app_slug].renderIcon({
                              ...iconSize,
                              fill: iconFill,
                            })
                          ) : route.sidebar_icon && !failedIcons.has(route.app_slug) ? (
                            <img
                              src={route.sidebar_icon}
                              alt="app-icon"
                              className={classes.sidebarIcon}
                              style={iconSize}
                              onError={() =>
                                setFailedIcons((prev) =>
                                  new Set(prev).add(route.app_slug)
                                )
                              }
                            />
                          ) : (
                            <BlockIcon
                              style={{
                                ...iconSize,
                                color: "#757575",
                              }}
                            />
                          )}
                        </div>
                      </ListItemIcon>
                      {props.fullscreen && (
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography
                              type="h3"
                              className={clsx([classes.label, typographyStyle])}
                            >
                              {hostConfig?.["custom_sidebar_labels"]?.[
                                route.path?.slice(1)
                              ] ||
                                hostConfig?.["custom_sidebar_labels"]?.[
                                  route.app_slug
                                ] ||
                                devicePreference.label ||
                                route.label ||
                                route.name}
                            </Typography>
                          }
                        />
                      )}
                    </ListItem>
                  </Link>
                  {/* <Divider /> */}
                </div>
              );
            })}
          </>
        </List>
      </Drawer>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    activeRoute: state.routeReducer.active_route,
    currentUser: state.userReducer.current_user,
    fullscreen: state.routeReducer.fullscreen,
    host: state.userReducer.host,
    theme: state.userReducer.theme,
    appLogo: state.userReducer.appLogo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveRoute: (route) => dispatch(updateActiveRouteAction(route)),
    updateActiveSubRouteIndex: (route) =>
      dispatch(updateActiveSubRouteIndexAction(route)),
    toggleFullScreen: (value) => dispatch(toggleFullScreen(value)),
  };
};

export default compose(
  withStyles({}, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(withRouter(Sidebar));
